/**
 * Custom next/image loader.
 * Files under /public are served as-is (SVGs can't go through the optimizer;
 * local PNGs 404 when forced through `/_next/image` with a custom loader).
 * Remote URLs still use the Next image optimizer.
 */
export default function nextImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  // Anything from /public (/, /agents/..., *.svg, *.png, …)
  if (
    typeof src === "string" &&
    src.startsWith("/") &&
    !src.startsWith("//")
  ) {
    return src;
  }

  const params = new URLSearchParams({
    url: src,
    w: String(width),
    q: String(quality ?? 75),
  });
  return `/_next/image?${params.toString()}`;
}
